import React from 'react';
import Title from '../../../../../@casino/ui/title';
import Table from '../../../../../@casino/ui/table';
import { useDispatch, useSelector } from 'react-redux';
import { setGetListGameFreespin } from '../../store/thunk/setGetListGameFreespin';
import {useRouter} from '../../../../../@casino/useRouter';

const ListGameFreespins = () => {
    const dispatch = useDispatch();
    const router = useRouter();
    const [activeCurrency, handleSetActiveCurrency] = React.useState('RUB')

    React.useEffect(() => {
        dispatch(setGetListGameFreespin({
            search: '',
            currency: 'RUB'
        }))
    }, []);

    const list = useSelector(state => state.freespinGame.list)

    const columns = [
        { id: 'uuid', label: 'uuid'},
        { id: 'game', label: 'Игра'},
        { id: 'bet_id', label: 'bet_id'},
        { id: 'denomination', label: 'denomination'},
        { id: 'total_bet', label: 'total_bet'},
        { id: 'change', label: ''}
    ];


    const rows = list.data.map((item) => {
        return {
            uuid: item.uuid,
            game: item.name,
            bet_id: item.bet_id,
            denomination: item.denomination,
            total_bet: item.total_bet,
            change: <span style={{cursor: 'pointer'}} onClick={() => router.history.push(`/freespin/game/edit/${item.id}`)}>Изменить</span>
        }
    })

    return (
        <div style={{
            padding: '0 20px'
        }}>
        <Title 
            label="Список игр для фриспинов" 
            labelBtn="Добавить игру" 
            button={() => router.history.push('/freespin/game/create')}
        />  
            <div style={{
                margin: '12px 0',
                display: 'flex',
                padding: '20px',
                background: '#1b2039',
                alignItems: 'center',
                borderRadius: '8px',
            }}>
                <div 
                    style={{width: 50, cursor: 'pointer', fontSize: 20, color: activeCurrency === 'RUB' ? 'rgb(255, 195, 36)' : '#FFF'}}
                    onClick={() => {
                        handleSetActiveCurrency('RUB');
                        dispatch(setGetListGameFreespin({
                            search: '',
                            currency: 'RUB'
                        }))
                    }}
                >
                    <span>RUB</span>
                </div>
                <div 
                    style={{width: 50, cursor: 'pointer', fontSize: 20, color: activeCurrency === 'USD' ? 'rgb(255, 195, 36)' : '#FFF'}}
                    onClick={() => {
                        handleSetActiveCurrency('USD');
                        dispatch(setGetListGameFreespin({
                            search: '',
                            currency: 'USD'
                        }))
                    }}    
                >
                    <span>USD</span>
                </div>
                <div 
                    style={{width: 50, cursor: 'pointer', fontSize: 20, color: activeCurrency === 'EUR' ? 'rgb(255, 195, 36)' : '#FFF'}}
                    onClick={() => {
                        handleSetActiveCurrency('EUR');
                        dispatch(setGetListGameFreespin({
                            search: '',
                            currency: 'EUR'
                        }))
                    }}    
                >
                    <span>EUR</span>
                </div>
                <div 
                    style={{width: 50, cursor: 'pointer', fontSize: 20, color: activeCurrency === 'TRY' ? 'rgb(255, 195, 36)' : '#FFF'}}
                    onClick={() => {
                        handleSetActiveCurrency('TRY');
                        dispatch(setGetListGameFreespin({
                            search: '',
                            currency: 'TRY'
                        }))
                    }}    
                >
                    <span>TRY</span>
                </div>
                <div 
                    style={{width: 50, cursor: 'pointer', fontSize: 20, color: activeCurrency === 'GEL' ? 'rgb(255, 195, 36)' : '#FFF'}}
                    onClick={() => {
                        handleSetActiveCurrency('GEL');
                        dispatch(setGetListGameFreespin({
                            search: '',
                            currency: 'GEL'
                        }))
                    }}    
                >
                    <span>GEL</span>
                </div>
                <div 
                    style={{width: 50, cursor: 'pointer', fontSize: 20, color: activeCurrency === 'UZS' ? 'rgb(255, 195, 36)' : '#FFF'}}
                    onClick={() => {
                        handleSetActiveCurrency('UZS');
                        dispatch(setGetListGameFreespin({
                            search: '',
                            currency: 'UZS'
                        }))
                    }}    
                >
                    <span>UZS</span>
                </div>
                <div 
                    style={{width: 50, cursor: 'pointer', fontSize: 20, color: activeCurrency === 'UZS' ? 'rgb(255, 195, 36)' : '#FFF'}}
                    onClick={() => {
                        handleSetActiveCurrency('KZT');
                        dispatch(setGetListGameFreespin({
                            search: '',
                            currency: 'KZT'
                        }))
                    }}    
                >
                    <span>KZT</span>
                </div>
            </div>

            <div style={{
                margin: '12px 0',
                display: 'flex',
                padding: '20px',
                background: '#1b2039',
                alignItems: 'center',
                borderRadius: '8px',
            }}>
                <Table
                    columns={columns}
                    rows={rows}
                />
            </div>
        </div>
    )
}

export default ListGameFreespins;